import React from 'react';
import FormInputHelpButton from './FormInputHelpButton';
import './FormInput.scss';

type FormInputProps = {
    id: string;
    label?: string;
    helpText?: string;
    errorText?: string;
    children?: React.ReactNode;
};

const FormInput = ({
    id,
    label,
    helpText,
    errorText,
    children
}: FormInputProps): JSX.Element => {
    const bodyClasses = errorText ? 'card-body card-body-error' : 'card-body';
    const labelClasses = label ? 'card-header header-left' : 'header-left';

    return (
        <div id={id} className='card formInput--card'>
            <div className='card-header-container'>
                <div className={labelClasses}>{label}</div>
                {helpText && (
                    <>
                        <FormInputHelpButton
                            id={id}
                            label={label}
                            helpText={helpText}
                        />
                    </>
                )}
            </div>
            <div className={bodyClasses}>{children}</div>
            {errorText && (
                <div className='card-footer card-footer-error alert-danger'>
                    {errorText}
                </div>
            )}
        </div>
    );
};

export default FormInput;
